<template>
	<div>
		<PageHeader
			:data="{
				name: municipality.name,
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Municipalities', to: '/municipalities' },
				],
			}"
		/>

		<div v-if="!loading" class="row">
			<div class="col-12 mb-2">
				<button data-bs-toggle="modal" data-bs-target="#salesforceModal" class="btn btn-secondary btn-sm me-2">
					Add to salesforce
				</button>
			</div>

			<div class="col-4">
				<div class="card mb-2">
					<div class="card-body">
						<div class="row border-bottom mb-2 pb-1">
							<div class="col-2">
								<h1>🏛️</h1>
							</div>
							<div class="col-10">
								<h4 class="mb-0">
									{{ municipality.full_name }}
									<a
										v-if="municipality.salesforce_account_id"
										target="_blank"
										:href="'https://hejdevdoo.lightning.force.com/lightning/r/Account/' + municipality.salesforce_account_id + '/view'"
										><img
											src="https://a.sfdcstatic.com/shared/images/c360-nav/salesforce-with-type-logo.svg"
											width="36"
											:title="'Salesforce ID' + municipality.salesforce_account_id"
										/>
									</a>
									<button class="btn btn-sm" @click="enableNameEdit = !enableNameEdit">Edit</button>
								</h4>
								<input v-if="enableNameEdit" type="text" class="form-control" v-model="municipality.full_name" />
								<span>{{ municipality.county }}, {{ municipality.state }} </span>
							</div>
						</div>

						<p class="m-0 p-0"><b>Population</b> 🧑‍🤝‍🧑 {{ municipality.population }}</p>
						<p class="m-0 p-0">
							<b>FIPS</b>:
							<a target="_blank" :href="'https://google.com/search?q=FIPS+' + municipality.fips">
								{{ municipality.fips }}
							</a>
						</p>
						<p class="m-0 p-0"><b>FIPS full</b>: {{ municipality.fips_full }}</p>
						<p v-if="municipality.deliveries" class="m-0 p-0"><b>Deliveries sent</b>: {{ municipality.deliveries.length }} 📨</p>
						<p v-if="municipality.contacts" class="m-0 p-0"><b>Contacts</b>: {{ municipality.contacts.length }} 👤</p>
						<p class="m-0 p-0" v-if="municipality.website">
							<b>Website</b>:
							<a v-if="municipality.website.includes('http')" :href="municipality.website" target="_blank">{{ municipality.website }} 🔗</a>
							<a v-else :href="'http://' + municipality.website" target="_blank">{{ 'http://' + municipality.website }} 🔗</a>
						</p>
						<div class="text-center mt-3">
							<a :href="municipality.wikipedia" target="_blank" class="btn btn-primary"
								><font-awesome-icon :icon="['fab', 'wikipedia-w']" class="me-2" /> Wikipedia</a
							>
						</div>
						<button v-if="authUser.email == 'srdjank90@gmail.com'" @click="deleteMunicipality()" class="btn btn-danger w-100 mt-3">
							<font-awesome-icon :icon="['fas', 'trash']" class="me-2" /> Delete
						</button>
					</div>
				</div>

				<div class="card mb-2" v-if="municipality && municipality.id">
					<div class="card-body">
						<PricingQuotesCard :municipality-id="municipality.id" title="Quotes 💬" />
					</div>
				</div>

				<div class="card mb-2">
					<div class="card-body">
						<div class="row border-bottom mb-2 pb-1">
							<div class="col-2">
								<h1>🤝🏿</h1>
							</div>
							<div class="col-10">
								<h4 class="mb-0">Customers</h4>
								<span>Municipality customer</span>
							</div>
						</div>
						<div class="row">
							<div class="col-6 mb-2">
								<div class="form-group">
									<label for="">TW Customer</label>
									<select class="form-select" v-model="municipality.tw_customer">
										<option value="0">No</option>
										<option value="1">Yes</option>
									</select>
								</div>
							</div>
							<div class="col-6 mb-2">
								<div class="form-group">
									<label for="">HG Customer</label>
									<select class="form-select" v-model="municipality.hg_customer">
										<option value="0">No</option>
										<option value="1">Yes</option>
									</select>
								</div>
							</div>
							<div class="col-12 mb-2">
								<div class="form-group">
									<label for="">Competitor 😠</label>
									<input class="form-control" type="text" v-model="municipality.competitor" />
								</div>
							</div>
							<div class="col-12 mb-2">
								<div class="form-group">
									<label for="">Competitor HG 😠</label>
									<input class="form-control" type="text" v-model="municipality.competitor_hg" />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="card mb-2">
					<div class="card-body">
						<!-- Campaigns status -->
						<div class="row mb-3">
							<h5>📩 Campaigns status</h5>
							<small class="mb-2">
								ℹ️ Municipality contact information
							</small>
							<div class="col-7 mb-2">
								<div class="form-group">
									<label for=""
										>Disable campaigns
										<span title="Don't send campaigns anymore to this municipality">ℹ️</span>
									</label>
									<select class="form-select" v-model="municipality.disable_campaigns">
										<option value="0">No</option>
										<option value="1">Yes</option>
									</select>
								</div>
							</div>
							<div class="col-5 mb-2">
								<div class="form-group">
									<label for="">Deliverable</label>
									<select class="form-select" v-model="municipality.deliverable">
										<option value="0">No</option>
										<option value="1">Yes</option>
									</select>
								</div>
							</div>

							<div class="col-6 mb-2">
								<div class="form-group">
									<label for="">PO Box Check</label>
									<input class="form-control" type="text" v-model="municipality.pobox_check" />
								</div>
							</div>
							<div class="col-6 mb-2">
								<div class="form-group">
									<label for="">Mail returned</label>
									<input class="form-control" type="text" v-model="municipality.mail_returned" />
								</div>
							</div>
							<div class="col-6 mb-2">
								<div class="form-group">
									<label for="">Last mail date</label>
									<input class="form-control" type="text" v-model="municipality.last_mail_date" />
								</div>
							</div>
							<div class="col-6 mb-2">
								<div class="form-group">
									<label for="">Last email date</label>
									<input class="form-control" type="text" v-model="municipality.last_email_date" />
								</div>
							</div>
						</div>
					</div>
				</div>

				<button
					v-if="authUser.permissions.includes('ACTIVITY_ACCESS') || authUser.email.includes('srdjan')"
					data-bs-toggle="offcanvas"
					data-bs-target="#offcanvasActivities"
					aria-controls="offcanvasActivities"
					class="btn btn-outline-secondary float-end"
					title="Contact history of changes"
					type="button"
				>
					<font-awesome-icon :icon="['fas', 'history']" /> History of changes
				</button>
			</div>
			<div class="col-8">
				<div class="card mb-2">
					<div class="card-body">
						<!-- Location info -->
						<div class="row mb-3">
							<h5>📍Location info</h5>
							<small class="mb-2">
								ℹ️ Note that only all fips information can provide exact match for municipality
							</small>
							<div class="col-2 mb-2">
								<div class="form-group">
									<label for="">State FIPS</label>
									<input class="form-control" :class="municipality.state_fips ? '' : 'border-danger'" type="text" v-model="municipality.state_fips" />
								</div>
							</div>
							<div class="col-2 mb-2">
								<div class="form-group">
									<label for="">County FIPS</label>
									<input class="form-control" :class="municipality.county_fips ? '' : 'border-danger'" type="text" v-model="municipality.county_fips" />
								</div>
							</div>
							<div class="col-2 mb-2">
								<div class="form-group">
									<label for="">Place FIPS</label>
									<input class="form-control" :class="municipality.place_fips ? '' : 'border-danger'" type="text" v-model="municipality.place_fips" />
								</div>
							</div>

							<div class="col-3 mb-2">
								<div class="form-group">
									<label for="">Latitude</label>
									<input class="form-control" type="text" v-model="municipality.lat" />
								</div>
							</div>

							<div class="col-3 mb-2">
								<div class="form-group">
									<label for="">Longitude</label>
									<input class="form-control" type="text" v-model="municipality.lng" />
								</div>
							</div>

							<div class="col-4 mb-2">
								<div class="form-group">
									<label for="">Name</label>
									<input class="form-control" type="text" v-model="municipality.name" />
								</div>
							</div>
							<div class="col-2 mb-2">
								<div class="form-group">
									<label for="">Type</label>
									<select class="form-select" v-model="municipality.type">
										<option value="City">City</option>
										<option value="Town">Town</option>
										<option value="Village">Village</option>
										<option value="Township">Township</option>
										<option value="Borough">Borough</option>
									</select>
								</div>
							</div>
							<div class="col-2 mb-2">
								<div class="form-group">
									<label for="">State</label>
									<input class="form-control" :class="municipality.state ? '' : 'border-danger'" type="text" v-model="municipality.state" />
								</div>
							</div>
							<div class="col-2 mb-2">
								<div class="form-group">
									<label for="">County</label>
									<input class="form-control" :class="municipality.county ? '' : 'border-danger'" type="text" v-model="municipality.county" />
								</div>
							</div>
							<div class="col-2 mb-2">
								<div class="form-group">
									<label for="">City</label>
									<input class="form-control" :class="municipality.city ? '' : 'border-danger'" type="text" v-model="municipality.city" />
								</div>
							</div>
							<div class="col-3 mb-2">
								<div class="form-group">
									<label for="">ZIP</label>
									<input class="form-control" type="text" v-model="municipality.zip" />
								</div>
							</div>
							<!-- <div class="col-2 mb-2">
								<div class="form-group">
									<label for="">PO BOX</label>
									<input class="form-control" type="text" v-model="municipality.pobox" />
								</div>
							</div> -->
							<div class="col-9 mb-2">
								<div class="form-group">
									<label for="">PO Box or Mailing address street </label>
									<input class="form-control" type="text" v-model="municipality.address_street" />
								</div>
							</div>
						</div>

						<!-- Contact info -->
						<div class="row mb-3">
							<h5>📇 Contact info</h5>
							<small class="mb-2">
								ℹ️ Municipality contact information
							</small>
							<div class="col-3">
								<div class="form-group">
									<label for="">Phone</label>
									<input class="form-control" type="text" v-model="municipality.phone" />
								</div>
							</div>
							<div class="col-4">
								<div class="form-group">
									<label for="">Email</label>
									<input class="form-control" type="email" v-model="municipality.email" />
								</div>
							</div>
							<div class="col-5">
								<div class="form-group">
									<label for="">Website</label>
									<input class="form-control" type="text" v-model="municipality.website" />
								</div>
							</div>
						</div>

						<!-- Other information -->
						<div class="row mb-3">
							<h5>💻 Other information</h5>
							<small class="mb-2">
								ℹ️ Municipality other information
							</small>
							<div class="col-8">
								<div class="form-group">
									<label for="">Wikipedia</label>
									<input class="form-control" type="text" v-model="municipality.wikipedia" />
								</div>
							</div>

							<div class="col-2">
								<div class="form-group">
									<label for="">Food stamp</label>
									<input class="form-control" type="text" v-model="municipality.food_stamp" />
								</div>
							</div>

							<div class="col-2">
								<div class="form-group">
									<label for="">Population</label>
									<input class="form-control" type="text" v-model="municipality.population" />
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<button v-if="authUser.permissions.includes('CONTACT_UPDATE')" @click="updateMunicipality()" class="btn btn-primary float-end">
									Update
								</button>
							</div>
						</div>
					</div>
				</div>

				<div class="card mb-2">
					<div class="card-body">
						<div class="row -mb-3">
							<h5>🕵️ Additional information about municipality features that they have</h5>
							<small class="mb-2">
								ℹ️ Note that only all fips information can provide exact match for municipality
							</small>
							<div class="col-3 mb-2">
								<div class="form-group">
									<label for="">311 🚩</label>
									<select class="form-select" v-model="municipality.issues">
										<option value="no">No</option>
										<option value="yes">Yes</option>
										<option value="maybe">Maybe</option>
									</select>
								</div>
							</div>
							<div class="col-3 mb-2">
								<div class="form-group">
									<label for="">Boat launch 🛥️</label>
									<select class="form-select" v-model="municipality.boat_launch">
										<option value="no">No</option>
										<option value="yes">Yes</option>
										<option value="maybe">Maybe</option>
									</select>
								</div>
							</div>
							<div class="col-3 mb-2">
								<div class="form-group">
									<label for="">Park rental 🏙️</label>
									<select class="form-select" v-model="municipality.park_rental">
										<option value="no">No</option>
										<option value="yes">Yes</option>
										<option value="maybe">Maybe</option>
									</select>
								</div>
							</div>
							<div class="col-3 mb-2">
								<div class="form-group">
									<label for="">Online payments 💳</label>
									<select class="form-select" v-model="municipality.online_payments">
										<option value="no">No</option>
										<option value="yes">Yes</option>
										<option value="maybe">Maybe</option>
									</select>
								</div>
							</div>
							<div class="col-3 mb-2">
								<div class="form-group">
									<label for="">Fillable forms 📝</label>
									<select class="form-select" v-model="municipality.fillable_forms">
										<option value="no">No</option>
										<option value="yes">Yes</option>
										<option value="maybe">Maybe</option>
									</select>
								</div>
							</div>
							<div class="col-3 mb-2">
								<div class="form-group">
									<label for="">Chat box 💬</label>
									<select class="form-select" v-model="municipality.chat_box">
										<option value="no">No</option>
										<option value="yes">Yes</option>
										<option value="maybe">Maybe</option>
									</select>
								</div>
							</div>
							<div class="col-5 mb-2">
								<div class="form-group">
									<label for="">Subscribe for alert notifications 📟</label>
									<select class="form-select" v-model="municipality.alert_notifications">
										<option value="no">No</option>
										<option value="yes">Yes</option>
										<option value="maybe">Maybe</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Add new card for Website Snapshots -->
				<div class="card mb-2">
					<div class="card-body">
						<h5>
							🌐 Website Snapshots
							<button @click="openWebsiteSnapshotsModal()" class="btn btn-primary btn-sm ms-2 float-end">
								View Snapshots
							</button>
						</h5>
						<small class="mb-2">
							ℹ️ View daily website snapshot data, response times, and status codes
						</small>
						
						<!-- Platform Fingerprint Changes Chart -->
						<div class="mt-4">
							<div class="border-top pt-3">
								<div class="d-flex justify-content-between align-items-center mb-3">
									<div class="d-flex align-items-center">
										<div class="me-2">
											<div class="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style="width: 32px; height: 32px;">
												<font-awesome-icon :icon="['fas', 'fingerprint']" class="text-primary" />
											</div>
										</div>
										<div>
											<h6 class="mb-0 fw-bold">Current Platform Fingerprints</h6>
											<small class="text-muted">Detected technologies as of {{ currentDate }}</small>
										</div>
									</div>
									<div class="d-flex gap-2 align-items-center">
										<div class="d-flex align-items-center gap-2">
											<label for="">Type:</label>
											<select class="form-select form-select-sm border-0 bg-light" v-model="platformFilterType" @change="onPlatformFilterChange" style="min-width: 120px;">
												<option value="">All Types</option>
												<option value="cms">CMS</option>
												<option value="provider">Provider</option>
												<option value="technology">Technology</option>
												<option value="hosting">Hosting</option>
												<option value="product">Product</option>
											</select>
										</div>
									</div>
								</div>

								<div class="bg-light bg-opacity-50 rounded p-3">
									<div v-if="loadingPlatformFingerprints" class="d-flex flex-column justify-content-center align-items-center h-100" style="min-height: 120px;">
										<div class="spinner-border text-primary mb-3" role="status">
											<span class="visually-hidden">Loading platform fingerprints...</span>
										</div>
										<p class="text-muted mb-0">Analyzing current platforms...</p>
									</div>

									<div v-else-if="platformFingerprints && platformFingerprints.length > 0">
										<div v-for="(platformGroup, type) in groupedPlatformFingerprints" :key="type" class="mb-4">
											<div class="d-flex align-items-center justify-content-between mb-3 p-2 bg-light bg-opacity-50 rounded">
												<div class="d-flex align-items-center">
													<span class="badge me-2 px-3 py-2" :class="getTypeBadgeClass(type)" style="font-size: 12px; font-weight: 600;">
														{{ type.toUpperCase() }}
													</span>
													<small class="text-muted fw-medium">{{ platformGroup.length }} platform{{ platformGroup.length !== 1 ? 's' : '' }}</small>
												</div>
											</div>
											
											<div class="row g-1 ms-2">
												<div v-for="platform in platformGroup" :key="platform.id" class="col-lg-4 col-xl-3">
													<div class="card border-0 bg-white shadow-sm h-100" style="border-left: 2px solid var(--bs-primary) !important;">
														<div class="card-body p-1">
															<h6 class="mb-0 fw-bold text-dark" style="font-size: 11px;">{{ platform.name }}</h6>
															<p class="text-muted mb-1 small" style="font-size: 9px; line-height: 1.1;">{{ platform.description }}</p>
															
															<div class="d-flex align-items-center">
																<font-awesome-icon :icon="['fas', 'search']" class="text-primary me-1" style="font-size: 8px;" />
																<small class="text-muted me-1" style="font-size: 9px;">Detected:</small>
																<small class="text-dark fw-medium" style="font-size: 9px;">
																	{{ platform.matched_pattern || platform.headers || 'N/A' }}
																</small>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										
										<div v-if="Object.keys(groupedPlatformFingerprints).length === 0" class="text-center py-4">
											<div class="mb-3">
												<div class="bg-secondary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center mx-auto" style="width: 48px; height: 48px;">
													<font-awesome-icon :icon="['fas', 'filter']" class="text-secondary fs-5" />
												</div>
											</div>
											<h6 class="text-muted mb-2">No platforms found</h6>
											<p class="text-muted mb-0 small">No platforms match the selected filter criteria.</p>
										</div>
									</div>

									<div v-else class="d-flex flex-column justify-content-center align-items-center h-100 text-center" style="min-height: 120px;">
										<div class="mb-3">
											<div class="bg-secondary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center mx-auto" style="width: 48px; height: 48px;">
												<font-awesome-icon :icon="['fas', 'search']" class="text-secondary fs-5" />
											</div>
										</div>
										<h6 class="text-muted mb-2">No Platform Fingerprints</h6>
										<p class="text-muted mb-0 small">
											No platform fingerprints detected for today.<br>
											Check back later for updates.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="card mb-2">
					<div class="card-body">
						<h5>
							📨 Campaigns
							<span v-if="autoCampaigns && autoCampaigns.length > 0" class="badge bg-primary ms-1">{{ autoCampaigns.length }}</span>
							<button @click="showDeliveries = !showDeliveries" class="btn btn-secondary btn-sm ms-2 float-end">
								<template v-if="!showDeliveries">Show</template>
								<template v-if="showDeliveries">Hide</template> campaigns
							</button>
						</h5>
						<small v-if="showDeliveries" class="mb-2">
							ℹ️ All campaigns sent to this municipality
						</small>

						<div v-if="loadingAutoCampaigns && showDeliveries" class="text-center py-3">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading campaigns...</span>
							</div>
						</div>

						<table v-if="showDeliveries && !loadingAutoCampaigns" :class="'table table-hover mt-2'">
							<thead>
								<tr>
									<th>Campaign Name</th>
									<th width="50">Type</th>
									<th width="150">Preview</th>
									<th>Sequence</th>
									<th>Status</th>
									<th>Sent Date</th>
								</tr>
							</thead>
							<tbody>
								<template v-if="autoCampaigns && autoCampaigns.length > 0">
									<template v-for="campaign in autoCampaigns">
										<tr :key="'auto-campaign-' + campaign.campaign_id + '-' + campaign.sent_at">
											<td class="align-middle">
												<div class="d-flex flex-column">
													<strong>{{ campaign.campaign_name }}</strong>
													<span class="campaign-type-badge" :class="getCampaignTypeClass(campaign.type)">
														<font-awesome-icon :icon="getCampaignTypeIcon(campaign.type)" class="me-1" style="font-size: 9px;" />
														{{ getCampaignTypeLabel(campaign.type) }}
													</span>
												</div>
											</td>
											<td class="align-middle text-center">
												<span class="mail-type-badge" :class="campaign.letter_pdf ? 'mail-letter' : 'mail-postcard'">
													<font-awesome-icon :icon="['fad', campaign.letter_pdf ? 'file-pdf' : 'image']" class="me-1" />
													{{ campaign.letter_pdf ? 'Letter' : 'Postcard' }}
												</span>
											</td>
											<td class="align-middle">
												<template v-if="campaign.letter_pdf">
													<a :href="storageUrl + campaign.letter_pdf" target="_blank" class="btn btn-sm btn-outline-primary">
														<font-awesome-icon :icon="['fad', 'file-pdf']" class="me-1" />
														View PDF
													</a>
												</template>
												<template v-else-if="campaign.postcard_front || campaign.postcard_back">
													<div class="d-flex gap-1">
														<div v-if="campaign.postcard_front" class="postcard-thumbnail-wrapper">
															<img :src="storageUrl + campaign.postcard_front" alt="Front" class="postcard-thumbnail" @error="handleImageError($event)" />
															<a :href="storageUrl + campaign.postcard_front" target="_blank" class="postcard-preview-overlay" @click.stop>
																<img :src="storageUrl + campaign.postcard_front" alt="Front Preview" class="postcard-preview-large" />
															</a>
															<small class="d-block text-center text-muted" style="font-size: 10px;">Front</small>
														</div>
														<div v-if="campaign.postcard_back" class="postcard-thumbnail-wrapper">
															<img :src="storageUrl + campaign.postcard_back" alt="Back" class="postcard-thumbnail" @error="handleImageError($event)" />
															<a :href="storageUrl + campaign.postcard_back" target="_blank" class="postcard-preview-overlay" @click.stop>
																<img :src="storageUrl + campaign.postcard_back" alt="Back Preview" class="postcard-preview-large" />
															</a>
															<small class="d-block text-center text-muted" style="font-size: 10px;">Back</small>
														</div>
													</div>
												</template>
											</td>
											<td class="align-middle">
												<span v-if="campaign.sequence_name">{{ campaign.sequence_name }}</span>
												<span v-else class="text-muted">-</span>
											</td>
											<td class="align-middle text-center">
												<span :class="getAutoCampaignStatusClass(campaign.status)">{{ getAutoCampaignStatusLabel(campaign.status) }}</span>
											</td>
											<td class="align-middle">{{ formatDate(campaign.sent_at) }}</td>
										</tr>
									</template>
								</template>
								<template v-else>
									<tr>
										<td colspan="6" class="text-center text-muted py-3">
											No campaigns found for this municipality
										</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>

				<div class="card mb-2">
					<div class="card-body">
						<h5 v-if="municipality.contacts && municipality.contacts.length > 0">
							👤 Contacts
							<button v-if="false" class="btn btn-success btn-sm">Export <font-awesome-icon :icon="['fas', 'file-csv']" class="me-1" /></button>
							<button @click="showContacts = !showContacts" class="btn btn-secondary btn-sm ms-2 float-end">
								<template v-if="!showContacts">Show</template>
								<template v-if="showContacts">Hide</template> contacts
							</button>
						</h5>
						<h5 v-if="municipality.contacts && municipality.contacts.length === 0">👤 Contacts <span class="fs-6 float-end">There is no contacts</span></h5>
						<small v-if="showContacts" class="mb-3">
							ℹ️ All municipalities contacts
						</small>

						<table v-if="showContacts" :class="'table table-hover mt-2'">
							<thead>
								<tr>
									<th>First name</th>
									<th>Last name</th>
									<th>Email</th>
									<th>Phone</th>
									<th>Title</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="contact in municipality.contacts">
									<tr :key="'edit-' + contact.id">
										<td class="align-middle">
											<a
												v-if="contact.salesforce_contact_id"
												target="_blank"
												:href="'https://hejdevdoo.lightning.force.com/lightning/r/Contact/' + contact.salesforce_contact_id + '/view'"
												class="me-1"
												><img
													src="https://a.sfdcstatic.com/shared/images/c360-nav/salesforce-with-type-logo.svg"
													width="24"
													:title="'Salesforce ID' + contact.salesforce_contact_id"
												/>
											</a>
											{{ contact.first_name }}
										</td>
										<td class="align-middle">
											{{ contact.last_name }}
										</td>
										<td class="align-middle">
											{{ contact.email }}
										</td>
										<td class="align-middle">
											{{ contact.phone }}
										</td>
										<td class="align-middle">
											{{ contact.title }}
										</td>
										<td class="align-middle">
											<router-link :to="'/contacts/edit/' + contact.id" class="btn btn-outline-primary btn-sm">Edit</router-link>
										</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="d-flex justify-content-center">
			<div class="spinner-border" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</div>

		<!-- Modal delivery info -->
		<div class="modal fade" id="deliveryInfoModal" tabindex="-1" role="dialog" aria-labelledby="deliveryInfoModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Delivery info</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body text-center">
						<template v-if="!loadingDeliveryInfo">
							<img v-if="deliveryInfo" :src="deliveryInfo.thumbnails[0].large" width="100%" class="mb-2" />

							🔍
							<a v-if="deliveryInfo" class="fs-5" target="_blank" :href="deliveryInfo.url"> Preview PDF file</a>
						</template>
						<div v-else class="d-flex justify-content-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>
		<!-- Modal for adding municipality to salesforce -->
		<div class="modal fade" id="salesforceModal" tabindex="-1" aria-labelledby="salesforceModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<div class="d-flex justify-content-start align-items-center">
							<h5 class="modal-title me-2">Add "{{ municipality.full_name }}" to Salesforce Accounts</h5>
						</div>

						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body mb-0">
						Do you want to add "{{ municipality.full_name }}" contacts too?
						<div class="form-check">
							<input class="form-check-input" type="radio" v-model="salesforce.addContacts" :value="false" id="contactsNo" />
							<label class="form-check-label" for="contactsNo">
								No, just add municipality to Accounts
							</label>
						</div>
						<div class="form-check">
							<input class="form-check-input" type="radio" v-model="salesforce.addContacts" :value="true" id="contactsYes" checked />
							<label class="form-check-label" for="contactsYes">
								Yes, add contacts also
							</label>
						</div>

						<div class="mt-3" v-if="salesforce.addContacts && municipality.contacts.length > 0">
							Choose witch contact to add:
							<table class="table table-hover">
								<thead>
									<tr>
										<td>
											<input class="form-check-input" type="checkbox" @click="toggleSelectAllContactsSF()" v-model="salesforce.selectAllContacts" />
										</td>
										<td>First Name</td>
										<td>Last Name</td>
										<td>Email</td>
									</tr>
								</thead>
								<tbody>
									<tr :key="contact.id" v-for="contact in municipality.contacts">
										<td>
											<input type="checkbox" class="form-check-input me-1" v-model="salesforce.selectedContacts" :value="contact.id" />
										</td>
										<td>{{ contact.first_name }}</td>
										<td>{{ contact.last_name }}</td>
										<td>{{ contact.email }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-if="salesforce.addContacts && municipality.contacts.length == 0">
							There is no contacts for this municipality in database
						</div>
					</div>
					<div class="modal-footer">
						<button v-if="!salesforce.loading" @click="createOnSalesforce()" class="btn btn-primary">
							<template v-if="!salesforce.addContacts">Add municipality</template>
							<template v-if="salesforce.addContacts">Add municipality and selected contacts</template>
						</button>
						<button v-if="salesforce.loading" class="btn btn-primary" type="button" disabled>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Creating...
						</button>
					</div>
				</div>
			</div>
		</div>
		<Activities :key="activityKey" :subjectType="'App\\Models\\Municipality'" :subjectId="$route.params.id" />

		<!-- Modal for displaying Website Snapshots -->
		<div class="modal fade" id="websiteSnapshotsModal" tabindex="-1" aria-labelledby="websiteSnapshotsModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">🌐 Website Snapshots - {{ municipality.website }}</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div v-if="loadingSnapshots" class="d-flex justify-content-center p-4">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading snapshots...</span>
							</div>
						</div>

						<div v-else-if="websiteSnapshots && websiteSnapshots.length > 0">
							<div class="table-responsive">
								<table class="table table-striped table-hover">
									<thead>
										<tr>
											<th>Date</th>
											<th>Status Code</th>
											<th>Response Time (ms)</th>
											<th>Muni Name Found</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="snapshot in websiteSnapshots" :key="snapshot.id">
											<td>{{ formatDate(snapshot.date) }}</td>
											<td>
												<span :class="getStatusCodeBadgeClass(snapshot.status_code)">
													{{ snapshot.status_code }}
												</span>
											</td>
											<td>{{ snapshot.response_time }}</td>
											<td>
												<span :class="snapshot.muni_name_exists ? 'badge bg-success' : 'badge bg-danger'">
													{{ snapshot.muni_name_exists ? 'Yes' : 'No' }}
												</span>
											</td>
											<td>
												<button @click="viewSnapshotContent(snapshot)" class="btn btn-sm btn-primary">
													<font-awesome-icon :icon="['fas', 'eye']" />
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						
						<div v-else class="alert alert-info">
							No website snapshots available for this municipality.
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for displaying Snapshot Content -->
		<div class="modal fade" id="snapshotContentModal" tabindex="-1" aria-labelledby="snapshotContentModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-scrollable">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Snapshot Content - {{ currentSnapshot ? formatDate(currentSnapshot.date) : '' }}</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div v-if="currentSnapshot" class="snapshot-content-preview">
							<div class="mb-3">
								<strong>Status Code:</strong> 
								<span :class="getStatusCodeBadgeClass(currentSnapshot.status_code)">
									{{ currentSnapshot.status_code }}
								</span>
								<strong class="ms-3">Response Time:</strong> {{ currentSnapshot.response_time }} ms
								<strong class="ms-3">Municipality Name Found:</strong> 
								<span :class="currentSnapshot.muni_name_exists ? 'badge bg-success' : 'badge bg-danger'">
									{{ currentSnapshot.muni_name_exists ? 'Yes' : 'No' }}
								</span>
							</div>
							
							<div v-if="currentSnapshot.loading" class="d-flex justify-content-center p-4">
								<div class="spinner-border" role="status">
									<span class="visually-hidden">Loading content...</span>
								</div>
								<span class="ms-2">Loading website content...</span>
							</div>
							
							<div v-else-if="currentSnapshot.error" class="alert alert-danger">
								{{ currentSnapshot.error }}
							</div>
							
							<div v-else-if="currentSnapshot.content" class="content-preview">
								<ul class="nav nav-tabs mb-3" id="contentTabs" role="tablist">
									<li class="nav-item" role="presentation">
										<button class="nav-link active" id="rendered-tab" data-bs-toggle="tab" data-bs-target="#rendered" type="button" role="tab">
											Rendered Preview
										</button>
									</li>
									<li class="nav-item" role="presentation">
										<button class="nav-link" id="source-tab" data-bs-toggle="tab" data-bs-target="#source" type="button" role="tab">
											Source Code
										</button>
									</li>
								</ul>
								<div class="tab-content" id="contentTabsContent">
									<div class="tab-pane fade show active" id="rendered" role="tabpanel">
										<div class="iframe-container border" style="height: 500px;">
											<iframe :srcdoc="currentSnapshot.content" frameborder="0" width="100%" height="100%"></iframe>
										</div>
									</div>
									<div class="tab-pane fade" id="source" role="tabpanel">
										<pre class="border p-3 bg-light" style="max-height: 500px; overflow: auto;">{{ currentSnapshot.content }}</pre>
									</div>
								</div>
							</div>
							<div v-else class="alert alert-warning">
								No content available for this snapshot.
							</div>
						</div>
						<div v-else class="alert alert-info">
							No snapshot selected.
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { handleErrors } from '../../actions/helpers'
import Activities from '@/components/Activities'
import PricingQuotesCard from '@/components/pricing/PricingQuotesCard.vue'
import { Modal } from 'bootstrap'
export default {
	name: 'MunicipalityEdit',
	components: { PageHeader, Activities, PricingQuotesCard },
	data() {
		return {
			loading: false,
			municipality: {
				name: '',
			},
			showContacts: false,
			showDeliveries: false,
			deliveryInfo: null,
			loadingDeliveryInfo: false,
			activityKey: 0,
			$salesforceModal: null,
			salesforce: {
				addContacts: false,
				selectedContacts: [],
				selectAllContacts: false,
				loading: false,
			},
			enableNameEdit: false,
			loadingSnapshots: false,
			websiteSnapshots: [],
			currentSnapshot: null,
			loadingPlatformFingerprints: false,
			platformFingerprints: [],
			platformFilterType: '',
			currentDate: new Date().toLocaleDateString(),
			uniquePlatformTypes: [],
			autoCampaigns: [],
			loadingAutoCampaigns: false,
		}
	},
	mounted() {
		this.$salesforceModal = new Modal('#salesforceModal')
		this.$websiteSnapshotsModal = new Modal('#websiteSnapshotsModal')
		this.$snapshotContentModal = new Modal('#snapshotContentModal')
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
		filteredPlatformFingerprints() {
			if (!this.platformFingerprints || !this.platformFilterType) {
				return this.platformFingerprints
			}
			return this.platformFingerprints.filter(platform => platform.type.toLowerCase() === this.platformFilterType.toLowerCase())
		},
		groupedPlatformFingerprints() {
			const platforms = this.filteredPlatformFingerprints || []
			const grouped = {}
			
			platforms.forEach(platform => {
				const type = platform.type.toLowerCase()
				if (!grouped[type]) {
					grouped[type] = []
				}
				grouped[type].push(platform)
			})
			
			// Sort groups by type name and platforms within each group by weight (descending)
			const sortedGrouped = {}
			Object.keys(grouped).sort().forEach(type => {
				sortedGrouped[type] = grouped[type].sort((a, b) => b.weight - a.weight)
			})
			
			return sortedGrouped
		},
	},
	created() {
		this.getMunicipality()
	},
	methods: {
		getMunicipality() {
			this.loading = true
			restApi
				.get(`/municipalities/${this.$route.params.id}`)
				.then(({ data }) => {
					this.loading = false
					this.municipality = data
					// Fetch platform fingerprint changes after municipality is loaded
					this.getPlatformFingerprintChanges()
					// Load campaigns history
					this.loadAutoCampaigns(data.id)
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
					this.loading = false
				})
		},

		updateMunicipality() {
			restApi
				.put(`/municipalities/${this.municipality.id}`, this.municipality)
				.then(() => {
					this.activityKey++
					this.$swal.fire({
						icon: 'success',
						title: 'Municipality successfully updated!',
						timer: 2000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		deleteMunicipality() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: `You won't be able to revert this! `,
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!',
					toast: false,
					timer: 0,
				})
				.then(result => {
					if (result.isConfirmed) {
						restApi
							.delete(`/municipalities/` + this.municipality.id)
							.then(() => {
								this.$router.push(`/municipalities`)
								this.$swal.fire({
									icon: 'success',
									title: `Municipality ${this.municipality.name} successfully deleted!`,
								})
							})
							.catch(error => {
								this.$swal.fire({
									icon: 'error',
									title: handleErrors(error, ''),
									timer: 6000,
								})
							})
					}
				})
		},

		getDeliveryInfo(type, lob_id) {
			this.loadingDeliveryInfo = true
			restApi
				.post(`/deliveries/info`, { type: type, lob_id: lob_id })
				.then(({ data }) => {
					this.deliveryInfo = data
					this.loadingDeliveryInfo = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
					this.loading = false
				})
		},

		// Select/Deselect all
		toggleSelectAllContactsSF() {
			this.selectedContacts = []
			if (!this.salesforce.selectAllContacts) {
				this.municipality.contacts.forEach(contact => {
					this.salesforce.selectedContacts.push(contact.id)
				})
			} else {
				this.salesforce.selectedContacts = []
			}
		},

		// Create on Salesforce
		createOnSalesforce() {
			this.salesforce.loading = true
			restApi
				.post(`/sf/account/${this.municipality.id}`, { contacts: this.salesforce.selectedContacts })
				.then(({ data }) => {
					console.log(data)
					this.salesforce.loading = false
					this.$salesforceModal.hide()
					this.getMunicipality()
					this.$swal.fire({
						icon: 'success',
						title: `Added municipality to Salesforce account!`,
					})
				})
				.catch(error => {
					this.$salesforceModal.hide()
					this.$swal.fire({
						icon: 'error',
						title: error.response.data.error,
						timer: 6000,
					})
					this.salesforce.loading = false
				})
		},

		openWebsiteSnapshotsModal() {
			this.loadingSnapshots = true
			this.$websiteSnapshotsModal.show()
			restApi
				.get(`/municipalities/${this.municipality.id}/website-snapshots`)
				.then(({ data }) => {
					this.loadingSnapshots = false
					this.websiteSnapshots = data
				})
				.catch(error => {
					this.loadingSnapshots = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		viewSnapshotContent(snapshot) {
			this.currentSnapshot = { ...snapshot, content: null, loading: true }
			this.$snapshotContentModal.show()
			
			// Call the worker API to get the actual content
			fetch(process.env.VUE_APP_CF_DATA_WORKER_URL, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					type: 'municipality_content',
					meta: {
						municipality_id: this.municipality.id,
						date: snapshot.date
					}
				})
			})
			.then(response => response.json())
			.then(data => {
				this.currentSnapshot = { ...snapshot, content: data.content || data, loading: false }
			})
			.catch(error => {
				console.error('Error fetching snapshot content:', error)
				this.currentSnapshot = { ...snapshot, content: null, loading: false, error: 'Failed to load content' }
			})
		},

		formatDate(date) {
			return new Date(date).toLocaleDateString()
		},

		getStatusCodeBadgeClass(statusCode) {
			if (statusCode >= 200 && statusCode < 300) {
				return 'badge bg-success'
			} else if (statusCode >= 300 && statusCode < 400) {
				return 'badge bg-warning'
			} else {
				return 'badge bg-danger'
			}
		},

		getLastOrCurrentMonday() {
			const today = new Date()
			const dayOfWeek = today.getDay() // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
			const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1 // If Sunday, go back 6 days; otherwise go back (dayOfWeek - 1) days
			const monday = new Date(today)
			monday.setDate(today.getDate() - daysToSubtract)
			return monday.toISOString().split('T')[0] // Format as YYYY-MM-DD
		},

		getPlatformFingerprintChanges() {
			this.loadingPlatformFingerprints = true
			const params = {
				date: this.getLastOrCurrentMonday()
			}

			if (this.platformFilterType) {
				params.type = this.platformFilterType
			}

			restApi
				.get(`/municipalities/${this.municipality.id}/platform-fingerprints`, { params })
				.then(({ data }) => {
					this.platformFingerprints = data
					this.uniquePlatformTypes = [...new Set(data.map(platform => platform.type.toLowerCase()))]
					this.loadingPlatformFingerprints = false
				})
				.catch(error => {
					this.loadingPlatformFingerprints = false
					console.error('Error fetching platform fingerprints:', error)
				})
		},

		onPlatformFilterChange() {
			if (this.municipality.id) {
				this.getPlatformFingerprintChanges()
			}
		},

		formatDateTime(date) {
			return date.toLocaleString()
		},

		getTypeBadgeClass(type) {
			const classes = {
				cms: 'bg-danger',
				provider: 'bg-primary',
				technology: 'bg-warning',
				hosting: 'bg-info',
				product: 'bg-success',
			}
			return classes[type] || 'bg-secondary'
		},

		loadAutoCampaigns(municipalityId) {
			if (!municipalityId) {
				this.loadingAutoCampaigns = false
				return
			}

			this.loadingAutoCampaigns = true
			restApi
				.get(`/municipalities/${municipalityId}/campaign-history`)
				.then(({ data }) => {
					this.autoCampaigns = data
					this.loadingAutoCampaigns = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, 'Failed to load campaigns'),
						timer: 6000,
					})
					this.autoCampaigns = []
					this.loadingAutoCampaigns = false
				})
		},

		getCampaignTypeClass(type) {
			const normalizedType = type.toLowerCase()
			const typeMap = {
				'auto_campaign': 'type-triggered',
				'triggered_campaign': 'type-triggered',
				'sequenced_campaign': 'type-sequenced',
				'legacy_campaign': 'type-legacy',
			}
			return typeMap[normalizedType] || 'type-unknown'
		},

		getCampaignTypeLabel(type) {
			const normalizedType = type.toLowerCase()
			const labelMap = {
				'auto_campaign': 'Auto',
				'triggered_campaign': 'Auto',
				'sequenced_campaign': 'Sequenced',
				'legacy_campaign': 'Legacy',
			}
			return labelMap[normalizedType] || type
		},

		getCampaignTypeIcon(type) {
			const normalizedType = type.toLowerCase()
			const iconMap = {
				'auto_campaign': ['fad', 'bolt'],
				'triggered_campaign': ['fad', 'bolt'],
				'sequenced_campaign': ['fad', 'list-ol'],
				'legacy_campaign': ['fad', 'clock-rotate-left'],
			}
			return iconMap[normalizedType] || ['fad', 'question']
		},

		handleImageError(event) {
			const img = event.target
			img.style.display = 'none'
			const placeholder = document.createElement('div')
			placeholder.className = 'postcard-thumbnail postcard-no-image'
			placeholder.innerHTML = '<span>No Image</span>'
			img.parentNode.insertBefore(placeholder, img)
		},

		getAutoCampaignStatusClass(status) {
			const statusMap = {
				'sent': 'badge bg-success',
				'completed': 'badge bg-success',
				'pending': 'badge bg-warning',
				'failed': 'badge bg-danger',
				'canceled': 'badge bg-secondary',
			}
			return statusMap[status.toLowerCase()] || 'badge bg-info'
		},

		getAutoCampaignStatusLabel(status) {
			const normalizedStatus = status.toLowerCase()
			if (normalizedStatus === 'completed') {
				return 'sent'
			}
			return status
		},

		watch: {
			$route(to, from) {
				if (to !== from) {
					location.reload()
				}
			},
		},
	},
}
</script>

<style scoped>
/* Campaign Type Badges */
.campaign-type-badge {
	display: inline-flex;
	align-items: center;
	padding: 2px 8px;
	font-size: 9px;
	font-weight: 500;
	border-radius: 10px;
	text-transform: capitalize;
	letter-spacing: 0.2px;
	margin-top: 4px;
	width: fit-content;
}

.type-triggered {
	background-color: rgba(74, 144, 226, 0.12);
	color: #357abd;
	border: 1px solid rgba(74, 144, 226, 0.25);
}

.type-sequenced {
	background-color: rgba(82, 196, 26, 0.12);
	color: #389e0d;
	border: 1px solid rgba(82, 196, 26, 0.25);
}

.type-legacy {
	background-color: rgba(140, 140, 140, 0.12);
	color: #595959;
	border: 1px solid rgba(140, 140, 140, 0.25);
}

/* Mail Type Badges */
.mail-type-badge {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 4px 10px;
	font-size: 11px;
	font-weight: 500;
	border-radius: 12px;
	transition: all 0.2s ease;
}

.mail-letter {
	background-color: rgba(255, 77, 79, 0.1);
	color: #cf1322;
	border: 1px solid rgba(255, 77, 79, 0.3);
}

.mail-postcard {
	background-color: rgba(114, 46, 209, 0.1);
	color: #531dab;
	border: 1px solid rgba(114, 46, 209, 0.3);
}

/* Postcard thumbnails */
.postcard-thumbnail-wrapper {
	position: relative;
	display: inline-block;
}

.postcard-thumbnail {
	width: 100px;
	height: 60px;
	object-fit: cover;
	border: 2px solid #e9ecef;
	border-radius: 6px;
	cursor: pointer;
	transition: all 0.2s ease;
}

.postcard-thumbnail:hover {
	border-color: #667eea;
	box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
	transform: scale(1.05);
}

/* Hover preview overlay */
.postcard-preview-overlay {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	opacity: 0;
	visibility: hidden;
	transition: opacity 0.3s ease, visibility 0.3s ease;
	z-index: 9999;
	pointer-events: none;
	cursor: pointer;
	text-decoration: none;
}

.postcard-thumbnail-wrapper:hover .postcard-preview-overlay {
	opacity: 1;
	visibility: visible;
	pointer-events: auto;
}

.postcard-preview-large {
	width: 400px;
	height: auto;
	max-height: 500px;
	object-fit: contain;
	border: 4px solid #667eea;
	border-radius: 12px;
	box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
	background: white;
	padding: 6px;
}

/* No image placeholder */
.postcard-no-image {
	width: 100px;
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f5f5f5;
	border: 2px dashed #d9d9d9;
	border-radius: 6px;
	color: #999;
	font-size: 10px;
	font-weight: 500;
	text-align: center;
	cursor: default;
}

.postcard-no-image:hover {
	border-color: #d9d9d9;
	box-shadow: none;
	transform: none;
}
</style>
